import { FaLayerGroup, FaShoppingCart, FaSmile, FaGlobe } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaLayerGroup />,
    title: 'Templates Available',
    count: '25',
  },
  {
    id: 2,
    icon: <FaShoppingCart />,
    title: 'Total Sales',
    count: '20',
  },
  {
    id: 3,
    icon: <FaSmile />,
    title: 'Happy Clients',
    count: '10',
  },
  {
    id: 4,
    icon: <FaGlobe />,
    title: 'Worldwide Users',
    count: '30',
  },
];

export default counter;